<template>
  <m-reset-email-password-1 :image="require('@/assets/user-login-svgrepo-com.svg')" class="my-5" />
</template>

<script>

export default {
  name: "ResetEmailPassword",
};
</script>
